import React from 'react';
import Radium from 'radium';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';

import styles from './styles';
import { selectIsAfterHours } from '../../app/ChatApp/selectors';
import messages from './messages';

class NewConversationButton extends React.Component {
  renderButtonText = () => {
    const { intl, isAfterHours, hasActiveSingleChat } = this.props;

    if (hasActiveSingleChat) {
      return intl.formatMessage(messages.new_conversation_singleChat);
    }

    if (isAfterHours) {
      return intl.formatMessage(messages.new_conversation_afterHours);
    }

    return intl.formatMessage(messages.new_conversation_inHours);
  };

  render() {
    const { onClick, hasMultipleActiveChats } = this.props;

    if (hasMultipleActiveChats) return null;

    return (
      <div style={styles.wrapper}>
        <div style={styles.button} onClick={onClick} className="kustomer-app-new-conversation-button">
          {this.renderButtonText()}
        </div>
      </div>
    );
  }
}

NewConversationButton.propTypes = {
  onClick: React.PropTypes.func,
  isAfterHours: React.PropTypes.bool,
  hasActiveSingleChat: React.PropTypes.bool,
  hasMultipleActiveChats: React.PropTypes.bool,
  intl: intlShape.isRequired,
};

NewConversationButton.defaultProps = {
  onClick: () => {},
  isAfterHours: false,
  hasActiveSingleChat: false,
  hasMultipleActiveChats: false,
};

const mapStateToProps = state => ({
  isAfterHours: selectIsAfterHours(state),
});

export default connect(mapStateToProps)(injectIntl(Radium(NewConversationButton), { withRef: true }));
